import React, { useState } from "react";
import { Button, Checkbox, CircularProgress, TextField, makeStyles } from "@material-ui/core";
import { Autocomplete, createFilterOptions } from "@material-ui/lab";
import { CheckRounded } from "@material-ui/icons";
import { toast } from "react-hot-toast";

const filtrarLibros = createFilterOptions({
  stringify: (libro) => `${libro.idLibro} ${libro.title ?? ""} ${libro.author ?? ""} ${libro.publisher ?? ""}`,
  limit: 80,
});

/**
 * Selector múltiple de libros disponibles para la sede.
 * La selección la controla el padre para poder conservarla al cambiar de curso.
 */
const SelectorLibros = ({
  catalogo = [],
  deshabilitados = new Map(),
  value = [],
  onChange,
  onAgregar,
  disabled = false,
}) => {
  const classes = useStyles();
  const [enviando, setEnviando] = useState(false);

  const agregar = async (e) => {
    e.preventDefault();
    if (!value.length) return;
    setEnviando(true);
    try {
      await onAgregar(value);
    } catch (error) {
      toast.error(error?.message || "No se pudo agregar los libros");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <form className={classes.form} onSubmit={agregar} autoComplete="off">
      <Autocomplete
        multiple
        disableCloseOnSelect
        limitTags={6}
        options={catalogo}
        filterOptions={filtrarLibros}
        value={value}
        onChange={(_, nuevo) => onChange(nuevo)}
        getOptionLabel={(libro) => `${libro.idLibro} - ${libro.title ?? ""}`}
        getOptionSelected={(a, b) => String(a.idLibro) === String(b.idLibro)}
        getOptionDisabled={(libro) => deshabilitados.has(String(libro.idLibro))}
        disabled={disabled || enviando}
        noOptionsText="Sin resultados"
        renderOption={(libro, { selected }) => (
          <div className="d-flex align-items-center w-100">
            <Checkbox size="small" checked={selected} style={{ marginRight: 6 }} />
            <div style={{ minWidth: 0 }}>
              <div className={classes.optionTitle}>{libro.title}</div>
              <div className="admin-muted-text-small">
                <code>{libro.idLibro}</code>
                {libro.author ? ` · ${libro.author}` : ""}
                {libro.publisher ? ` · ${libro.publisher}` : ""}
                {deshabilitados.has(String(libro.idLibro)) && (
                  <strong style={{ color: "#6c757d" }}>
                    {" "}
                    · {deshabilitados.get(String(libro.idLibro))}
                  </strong>
                )}
              </div>
            </div>
          </div>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            size="small"
            placeholder={value.length ? "" : "Buscar por ID, título, autor o editorial"}
          />
        )}
        className={classes.autocomplete}
      />
      <Button
        type="submit"
        variant="contained"
        disabled={disabled || enviando || !value.length}
        startIcon={enviando ? <CircularProgress size={16} color="inherit" /> : <CheckRounded />}
        classes={{ root: classes.addBtn }}
      >
        {value.length ? `Agregar ${value.length} al curso` : "Agregar al curso"}
      </Button>
    </form>
  );
};

export default SelectorLibros;

const useStyles = makeStyles({
  form: {
    display: "flex",
    gap: 12,
    flexWrap: "wrap",
    alignItems: "flex-start",
  },
  autocomplete: {
    flex: "1 1 360px",
    background: "#fff",
  },
  optionTitle: {
    fontSize: "0.95em",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  addBtn: {
    background: "#81c868",
    color: "#fff",
    height: 40,
    "&:hover": { backgroundColor: "#6fb558" },
    "&.Mui-disabled": { background: "#cdeac3", color: "#fff" },
  },
});
